import type { ProfileMe, Relationship } from '@/lib/types';

/** Marital_Status_ID values that mean "there is a spouse to link". */
const MARRIED_STATUSES = new Set([2, 5]);
/** Relationships.Relationship_ID for "Married to" (Husband / Wife). */
export const MARRIED_TO_ID = 1;

export function isMarried(maritalStatusId: number | null): boolean {
  return maritalStatusId !== null && MARRIED_STATUSES.has(maritalStatusId);
}

/** The "Married to" relationship from the lookups, by id first, by name as a fallback. */
export function marriedToRelationship(data: ProfileMe): Relationship | null {
  const all = data.lookups.relationshipTypes.flatMap((t) => t.relationships);
  return (
    all.find((r) => r.id === MARRIED_TO_ID) ??
    all.find((r) => /married|spouse/i.test(r.name)) ??
    null
  );
}

/** Whoever is linked to me as "Married to": a household member first, then family elsewhere. */
export function findSpouse(
  data: ProfileMe
): { displayName: string; imageUrl: string | null } | null {
  const rel = marriedToRelationship(data);
  const id = rel?.id ?? MARRIED_TO_ID;
  const member = data.members.find((m) => m.relationship?.relationshipId === id);
  if (member) return member;
  const outside = data.me.family.find((f) => f.relationshipId === id);
  return outside ? { displayName: outside.displayName, imageUrl: outside.imageUrl } : null;
}
